export const COMPANY_TYPE = 'company';
